// import axios from 'axios'
import baseURL from '../baseUrl'

// 列表
export function list(uid, token, supplier_id, startTime, endTime, page, withdraw_status) {
  var url=baseURL?'/merchant':'/api/merchant'
  return axios({
    url,
    method: 'post',
    params: {
      user_id: uid,
      supplier_id: supplier_id,
      token: token,
      startTime: startTime,
      endTime: endTime,
      page: page,
      withdraw_status: withdraw_status
    }
  })
}

// 绑定手机号 修改密码
export function bindphone(data, uid, token, supplier_id) {
  var url=baseURL?'/merchantedit':'/api/merchantedit'
  return axios({
    url,
    method: 'post',
    params: {
      user_id: uid,
      supplier_id: supplier_id,
      browser_token: token,
      mobile: data.mobile,
      Vcode: data.code,
      password: data.password,
      repassword: data.repassword
    }
  })
}

// 提现
export function cashformsub(data, uid, browser_token, supplier_id) {
  var url=baseURL?'/cashformsub':'/api/cashformsub'
  return axios({
    url,
    method: 'post',
    params: {
      user_id: uid,
      supplier_id: supplier_id,
      browser_token: browser_token,
      amount: data.amount,
      password: data.password,
      remark: data.remark
    }
  })
}


// 获取订单相关信息
export function getSupplierUnreadMessage(data) {
  var url=baseURL?'/pc_getSupplierUnreadMessage':'/api/pc_getSupplierUnreadMessage'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/merchant/merchant.js